<!-- Toast Messages -->
<p-toast
  data-testid="synchronization-form-toast"
  position="top-right"
  [baseZIndex]="9999"
  [autoZIndex]="true"
  [showTransformOptions]="'translateX(100%)'"
  [hideTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'0.3s ease-in'"
  [hideTransitionOptions]="'0.3s ease-out'"
  [preventDuplicates]="false"
></p-toast>

<app-add-form
  data-testid="synchronization-form"
  [title]="config.title"
  [formFields]="config.formFields"
  [headerActions]="config.headerActions"
  [sectionButtons]="sectionButtons"
  [tableSections]="updatedTableSections()"
  [editMode]="editMode"
  [viewMode]="viewMode"
  [initialData]="combinedInitialData()"
  [loading]="loading()"
  [getFieldError]="getFieldError.bind(this)"
  (formAction)="onFormAction($event)"
  (sectionAction)="onSectionAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
  (tableAction)="onTableAction($event)"
  scrollHeight="450px"
  [height]="height"
>
</app-add-form>

<!-- Unified Selection Dialog -->
<app-selection-dialog
  data-testid="synchronization-form-selection-dialog"
  [visible]="showSelectionDialog()"
  [config]="currentDialogConfig()"
  [items]="dialogItems()"
  [loading]="dialogLoading()"
  [totalRecords]="dialogTotalRecords()"
  [initialSelection]="dialogInitialSelection()"
  [disabledSelection]="dialogDisabledSelection()"
  (visibleChange)="showSelectionDialog.set($event)"
  (selectionConfirm)="onSelectionConfirm($event)"
  (search)="onDialogSearch($event)"
  (searchReset)="onDialogSearchReset()"
  (pageChange)="onDialogPageChange($event)"
>
</app-selection-dialog>

<!-- Delete Confirmation Dialog -->
<app-confirmation-dialog
  [testId]="'synchronization-form-delete-confirmation-dialog'"
  [(visible)]="showDeleteConfirmationDialog"
  [title]="deleteConfirmationTitle"
  [message]="deleteConfirmationMessage"
  [buttons]="deleteConfirmationButtons"
  (emitOnClick)="onDeleteConfirmatiButtonClick($event)"
></app-confirmation-dialog>

<app-fefo-override-dialog
  [(visible)]="fefoOverrideVisible"
  [data]="fefoOverrideData"
  (result)="onFefoOverrideResult($event)"
></app-fefo-override-dialog>
